// Non-translated constants for projects (images + external links)
export const PROJECT_ASSETS = {
  "objekt-komercial-essen": {
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_70aa06d5-40fa-41d1-9a3c-79616c75b465/artifacts/3i1cmz72_photo_2026-07-16_17-18-06.jpg",
    buttons: {
      plans:
        "https://drive.google.com/file/d/1dv-ptY3JGEX_sem1VvbToMXzff3JBt-L/view?usp=drivesdk",
      details:
        "https://drive.google.com/file/d/13968kFt4VEb_Nau4pO5QEFfF31hqjDqB/view?usp=sharing",
    },
  },
  kindertagesstaette: {
    image:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_projekt-studio/artifacts/1o77zq2v_IMG_4200.jpeg",
    externalUrl:
      "https://drive.google.com/file/d/1ijl_-15ooaS64H5UxFtFxi3WOGNzc74R/view?usp=drivesdk",
    buttons: {
      view: "https://drive.google.com/file/d/1ijl_-15ooaS64H5UxFtFxi3WOGNzc74R/view?usp=drivesdk",
    },
  },
  "villa-schweiz-pool": {
    image:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_projekt-studio/artifacts/91ukjfl1_8DE8C630-2057-427B-8395-6F655D3669FB.webp",
    externalUrl:
      "https://drive.google.com/file/d/1rpYq6ztoIjGFfRLHgbPy0hH2ZRWmtTSV/view?usp=drivesdk",
    buttons: {},
  },
  "moschee-dortmund": {
    image:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_projekt-studio/artifacts/hgfurwyn_IMG_4211.jpeg",
    buttons: {
      architektur:
        "https://drive.google.com/file/d/1Qk8551wYecJrs-BNj23ebZLvI7H6eyjO/view?usp=drivesdk",
      elektro:
        "https://drive.google.com/file/d/1Pe-8Uh1tGiHhjwC6lcpURyq1cQyuba-p/view?usp=drivesdk",
    },
  },
  "doni-fruits-lagerhalle": {
    image:
      "https://customer-assets-7cd3h4nn.emergentagent.net/job_projekt-studio/artifacts/b5g6ndty_IMG_4213.jpeg",
    externalUrl:
      "https://drive.google.com/file/d/16aiNE0gl-B9oFZI3WptsyV1LO-b8ng61/view?usp=drivesdk",
    buttons: {},
  },
};

export const getProjectAsset = (slug) => PROJECT_ASSETS[slug] || null;
